import { Component, computed, inject, output, ChangeDetectionStrategy } from '@angular/core';
import { LayoutService } from '../../services/layout.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ToolbarSearch } from './toolbar-search/toolbar-search';
import { ToolbarUser } from './toolbar-user/toolbar-user';
import { ToolbarNotifications } from './toolbar-notifications/toolbar-notifications';
import { PwaInstallService } from '../../../services/pwa-install.service';
import { FeatureFlagService } from '../../../feature-flags';
import { CopilotService } from '../../../../features/provid/copilot/services/copilot.service';

@Component({
  selector: 'app-toolbar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    ToolbarSearch,
    ToolbarNotifications,
    ToolbarUser
  ],
  templateUrl: './toolbar.html',
  styleUrl: './toolbar.scss',
})
export class Toolbar {

  private router = inject(Router);
  private layoutService = inject(LayoutService);
  protected readonly pwaInstallService = inject(PwaInstallService);
  readonly flagService = inject(FeatureFlagService);
  readonly copilot = inject(CopilotService);

  isMobile = this.layoutService.isMobile;
  sidenavExpanded = this.layoutService.sidenavExpanded;
  
  toggleQuickpanelRequest = output<void>();
  toggleSidenavRequest = output<void>();

  // Título dinâmico baseado na rota
  private routeTitle = toSignal(
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => this.getTitleFromRoute())
    ),
    { initialValue: this.getTitleFromRoute() }
  );

  title = computed(() => this.routeTitle() || 'Nexus');

  toggleSidenav(): void {
    if (this.isMobile()) {
      this.layoutService.toggleSidenav();
    } else {
      this.toggleSidenavRequest.emit();
    }
  }

  toggleQuickpanel(): void {
    this.toggleQuickpanelRequest.emit();
  }

  async instalarApp(): Promise<void> {
    await this.pwaInstallService.promptInstall();
  }

  // TODO: Adicionar as rotas e os títulos baseado no arquivo de rotas
  private getTitleFromRoute(): string {
    const url = this.router.url;
    
    if (url.includes('/inicio')) return 'Início';
    if (url.includes('/consultas')) return 'Consultas';
    if (url.includes('/copom')) return 'Chamados 190';
    if (url.includes('/sentinela')) return 'DF 360';
    if (url.includes('/relatorio')) return 'Relatório (RAP)';
    if (url.includes('/viatura')) return 'Viatura';
    if (url.includes('/config')) return 'Configurações';
    
    return 'Nexus';
  }
}
